import { TYPO } from "styles/Typo";
import moment from "moment";
import { memo } from "react";
import { filterMarkdown } from "utils/format";
import ReportThumb from "components/templates/common/components/ReportThumb";
import { TrackedListItem } from "lib/analytics/react/list";

function ResearchItem({ data, index }: { data: any; index: number }) {
  return (
    <TrackedListItem
      itemData={{
        kind: "report",
        report_id: data?.id,
        rank: index + 1,
      }}
      href={`/discuss/${
        data?.url_slug ? `${data?.url_slug}-${data?.id}` : data?.id
      }`}
      className="px-6 py-4 flex items-center gap-4 w-full"
      data-gtm-id={`sDetail-debate-genius-list-2`}
    >
      <div className="flex flex-col gap-2 w-0 flex-1">
        <p className={`${TYPO.TYPO7_SB} text-gray90 truncate`}>{data?.title}</p>
        <span className={`${TYPO.TYPO8_RG} text-gray80  line-clamp-2`}>
          {filterMarkdown(data?.intro)}
        </span>
        <p className={`${TYPO.TYPO8_RG} text-gray80`}>
          {moment(data?.issue_at).format("YYYY.MM.DD")}
        </p>
      </div>
      <ReportThumb
        data={data}
        width={90}
        height={67}
        className="rounded-[14px] flex-shrink-0"
      />
    </TrackedListItem>
  );
}
const MemoResearchItem = memo(ResearchItem);
MemoResearchItem.displayName = "MemoResearchItem";

export default MemoResearchItem;
